module.exports = __webpack_public_path__ + "static/media/20.6d4bda6a.png";